import type { Title, TitleDto } from '../types';

export function titleFromDto(dto: TitleDto): Title{
  return {
    id: dto.id,
    label: dto.label,
    name: dto.titl_name,
    short: dto.titl_short,
  };
}
